import { render, staticRenderFns } from "./OEMBacklog-Stacked.vue?vue&type=template&id=3b3b9ecf&"
import script from "./OEMBacklog-Stacked.vue?vue&type=script&lang=js&"
export * from "./OEMBacklog-Stacked.vue?vue&type=script&lang=js&"
import style0 from "./OEMBacklog-Stacked.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports